<ng-container *ngIf="!showDiploma && activeLevelNumber !== null">
  <div class="fullScreenGame" *ngIf="activeType ==='GameVideo' || activeType === 'GameClicker'">
    <template #fullScreenGameTemplateContainer
    >
    </template>
  </div>


  <section *ngIf="activeType !== 'GameVideo'">
    <!-- <div *ngIf="activeType==='GameClicker'" class="game-clicker-container">
      <app-game-clicker *ngIf="activeGame" [game]="activeGame" [activeLevelId]="activeLevelNumber" (completed)="gameFinished()"></app-game-clicker>
    </div> -->
    <app-responsive-popup [caption]="caption"  *ngIf="activeType!=='GameClicker'" >
      <template #gameTemplateContainer
        *ngIf="showGameEndScreen !== true && showLevelEndScreen !== true && showDiplomaEndScreen !== true"
      >
      </template>
      <app-game-completed [game]="activeGame" *ngIf="showGameEndScreen" (close)="closeEndScreen()">
        <span [innerHtml]="gameFinishedText"></span>
      </app-game-completed>
      <app-game-level-completed [activeLevelNumber]="activeLevelNumber" *ngIf="showLevelEndScreen" (close)="closeLevelEndScreen()"></app-game-level-completed>

    </app-responsive-popup>

  </section>
</ng-container>

<app-diploma *ngIf="showDiplomaEndScreen" (closeEndScreen)="closeEndScreen()"></app-diploma>
